import React, { useState, useEffect } from "react";
import { Link, Paper, TextField, Button } from "@material-ui/core/";
import "./LogIn.css";

let langData = require("../../../Data/language.json");

export default function LogIn(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  var lastTouchEnd = 0;

  useEffect(() => {
    document.addEventListener("touchEnd", (evt) => disableDoubleTap(evt));
    return () => {
      window.removeEventListener("touchEnd", disableDoubleTap);
    };
  }, []);

  useEffect(() => {
    props.emptyErrorMsg();
  }, [email, password]);

  const disableDoubleTap = (evt) => {
    const now = new Date().getTime();
    if (now - lastTouchEnd <= 300) {
      evt.preventDefault();
    }
    lastTouchEnd = now;
  };
  return (
    <div className="container-fluid col-lg-8 col-md-11 col-sm-11">
      <Paper
        className="container-fluid"
        id="logInContainer"
        elevation={6}
        square
      >
        <div className="inputWrapper">
          <h3>{langData[props.language].login.title}</h3>
          <TextField
            id="custom-css-outlined-input1"
            label={langData[props.language].login.email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            margin="normal"
            variant="outlined"
          />
          <br />
          <TextField
            id="outlined-password-input"
            label={langData[props.language].login.password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            margin="normal"
            variant="outlined"
          />
          <p>{props.errorTxt}</p>

          <Button
            variant="outlined"
            onClick={() => props.onLogIn(email, password)}
          >
            {langData[props.language].login.logInBtn}
          </Button>
          {props.showLoader ? (
            <div className="container-fluid loaderContainer col-6">
              <div className="tinyLoader"></div>
            </div>
          ) : null}
          <br />
          <Link
            component="button"
            color="inherit"
            variant="body2"
            onClick={() => props.toggleInputMode("forgotPassword")}
          >
            {langData[props.language].login.forgotPassword}
          </Link>
          <hr />

          <div className="container-fluid col-6 registerContainer">
            <Button
              variant="outlined"
              onClick={() => props.toggleInputMode("register")}
            >
              {langData[props.language].login.register}
            </Button>
          </div>
        </div>
      </Paper>
    </div>
  );
}
